import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 50px;
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
`;

export const Titulo = styled.h4`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textBackground};
`;
